import data from "../../shared/sharedData";

const fieldsToClear = [
  "appAEduOther",
  "appAEduMajors",
  "appAEduInstName",
  "appAEduCountryId",
  "appAEduMonthYearAttained",
];

export default {
  name: "Appendix A.B - Foreign Worker Education",
  pageInfo: {
    text: "<b><u>Note:</u></b> This section is required if there is an educational requirement for the job opportunity. Identify any relevant diplomas/degrees attained that qualify the foreign worker for the job opportunity for which the employer is seeking permanent labor certification.  List the most recent diploma/degree attained first and complete every field for each set.  This section will collect five (5) sets of diplomas/degrees.  For electronic filings, if the employer needs to disclose more sections of educational attainment information, the filing system will automatically provide the employer with the option of adding more sets until all required responses are completed.  For mailed or paper filings, the employer will make one or more copies of educational attainment sets B.c through B.e under this section of the Appendix to complete and attach to the Form ETA-9089.<b><i> Submission of additional educational information in any other form or format will not be accepted.</i></b><br/><br/>If the foreign worker does not hold relevant U.S. diplomas/degrees or foreign equivalent, mark “None” in question 1 and in questions 1a through 1e, enter “N/A” or leave blank, as appropriate.  Where the foreign worker attained a diploma/degree outside the U.S., mark “Other” and specify the U.S. equivalent of the diploma/degree.",
    coloring: "grey",
  },
  pageAlert: {
    widget: "pageAlert",
    alerts: [
      {
        isVisible: {
          when: "appAEduTypeId",
          is: "None",
          operator: "compareFieldValuesModal",
          modal: "fwEducationAppB",
        },
        title: "Section Complete",
        description:
          "You marked None, indicating that the foreign worker does not have the relevant U.S. diploma/degree or foreign equivalent. To add an education requirement, please update 'None' to the actual U.S. diploma/degree or foreign equivalent.",
        type: "info",
      },
    ],
  },
  sections: [
    {
      code: "Appendix A.B",
      machine_name: "fwEducationAppB",
      isModal: true,
      removeFromFieldArray: true,
      openModalHeader: "Add Foreign Worker Education",
      modalHeader: "Add Foreign Worker Education",
      sectionHeader: "Foreign Worker Education",
      listType: "table",
      sortBy: { field: "appAEduMonthYearAttained", type: "date" },
      hide: (formApi) => {
        const fieldArray = formApi.getState().values.fwEducationAppB;
        for (var i in fieldArray) {
          const data = fieldArray[i]?.appAEduTypeId;
          if (data === "None") return true;
        }
      },
      validate: [
        {
          tableRequiredIf: "appendixABRequired",
          message: "Please enter at least one row.",
          needsFieldValues: true,
          extraData: {
            valueOf: true,
          },
        },
      ],
      editButton: true,
      removeLink: "Remove Foreign Worker Education",
      modalFields: [
        {
          hideOnTable: false,
          tableHeader: "Education",
          isGroup: {
            code: "1",
            machine_name: "appAEduTypeId",
            required: true,
            label:
              "Education: U.S Diploma/Degree attained relevant to the job opportunity",
            clearBtn: {
              clearSchema: [],
            },
            tooltip:
              "Identify whether the foreign worker’s minimum U.S. diploma or degree, relevant to the job opportunity, is None, High school/GED, Associate, Bachelor’s, Master’s, Doctorate, or Other degree.  Only mark one box.  If no relevant diploma or degree, enter “N/A.”",
            fields: [
              {
                widget: "radio",
                choice: "None",
                value: "None",
                parent_machine_name: "add_values_field",
                clearSchema: fieldsToClear,
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "High School/GED",
                value: "High School/GED",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Associate",
                value: "Associate",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Bachelor's",
                value: "Bachelor's",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Master's",
                value: "Master's",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Doctorate (PhD)",
                value: "Doctorate (PhD)",
                parent_machine_name: "add_values_field",
                clearSchema: ["appAEduOther"],
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
              {
                widget: "radio",
                choice: "Other Degree (JD, MD, etc.)",
                value: "Other Degree",
                validate: [
                  {
                    isRequired: "appendixABRequired",
                    message: "This field is required",
                    needsFieldValues: true,
                    extraData: {
                      valueOf: true,
                    },
                  },
                ],
              },
            ],
          },
        },
        {
          code: "1.a",
          machine_name: "appAEduOther",
          label:
            'If "Other Degree" in question 1, specify the diploma/degree attained',
          widget: "text",
          hideOnTable: true,
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: ["Other Degree"],
            operator: "compareMultiFieldValuesAND_ORInArray",
          },
          maxLength: 120,
          tooltip:
            "If you marked “Other” in question 1, enter the specific U.S. diploma or degree received (e.g., JD, MD, DDS, foreign equivalent or credentialing service, etc.).  If you did not mark “Other” in question 1, or no relevant diploma/degree, enter “N/A.”",
        },
        {
          code: "1.b",
          machine_name: "appAEduMajors",
          label:
            "Specify major(s) and/or field(s) of study (may list more than one related major and more than one field)",
          tableHeader: "Major",
          widget: "text",
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          maxLength: 120,
          tooltip:
            "Enter the foreign worker’s major(s) and/or field(s) of study for the diploma or degree indicated in question 1.  You may list more than one field and/or more than one related major.  If you marked “None” or “High School” in question 1, or no relevant diploma/degree, enter “N/A.”",
        },
        {
          code: "1.c",
          machine_name: "appAEduInstName",
          label: "Name of Institution that issued the degree/diploma",
          tableHeader: "Institution",
          widget: "text",
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "High School/GED",
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          maxLength: 120,
          tooltip:
            "Enter the name of the institution where the foreign worker received the diploma or degree identified in question 1.  If no relevant diploma/degree, enter “N/A.”",
        },
        {
          code: "1.d",
          machine_name: "appAEduCountryId",
          label: "Name of Country of institution identified in question 1c",
          tableHeader: "Country",
          widget: "select",
          selection: data.country,
          validate: ["required"],
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "High School/GED",
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          tooltip:
            "Enter the country of the institution identified in question 1c.  If no relevant diploma or degree, enter “N/A.”",
        },
        {
          code: "1.e",
          machine_name: "appAEduMonthYearAttained",
          label: "Month/year attained",
          tableHeader: "Month/Year",
          widget: "text",
          parse: "monthYear",
          maxLength: 7,
          isVisible: {
            when: "appAEduTypeId",
            is: [
              "High School/GED",
              "Associate",
              "Bachelor's",
              "Master's",
              "Doctorate (PhD)",
              "Other Degree",
            ],
            operator: "||",
          },
          validate: [
            "required",
            {
              monthYear: "appATrainingStartDate",
              message: "mm/yyyy format required",
            },
            {
              validMonth: "appAEduMonthYearAttained",
              message: "a valid month is required",
            },
            {
              dateStartEnd: "appAContDOB",
              message:
                "Date entered must be after the Foreign Worker’s Date of Birth.",
              needsFieldValues: true,
              extraData: {
                prefix: "add_values_field",
                type: "end",
                currentField: "appAEduMonthYearAttained",
                customDateFormat: "MM/YYYY",
                isModal: true,
              },
            },
            "noFutureDateTextFields",
          ],
          tooltip:
            "Enter the <u>month and year</u> the foreign worker received the diploma or degree identified in question 1. Use a full year (MM/YYYY) format. If no relevant diploma or degree, leave blank.",
        },
      ],
    },
  ],
};
